import { MissionToStaffReportInput } from '../../lib/types/models/mission-to-staff/mission-to-staff.input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function submitMissionToStaffReport(input: IdInput<MissionToStaffReportInput>) {
  const { id: missionToStaffId, ...rest } = input
  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.submitMissionToStaffReport.url, { id: missionToStaffId })
    )
    .post<MissionToStaffReportInput>(rest)
}
